import React from "react";
import PropTypes from "prop-types";
import { LandCodes } from "../../constants/DomainConstants";

import Row from "./Row";
import AutoComplete from "./AutoComplete";
import TextAreaInput from "./TextAreaInput";
import TextInput from "./TextInput";
import ConfirmModal from "./ConfirmModal";
import SelectInput from "./SelectInput";

const AdresInput = (props) => {
	const {
		model,
		originalModel,
		errors,
		landen,
		postcodeGemeenten,
		straten,
		beschrCorrespAdressen,
		onChange,
		stratenLoading,
		showUnknownToPartnerModal,
		confirmUnknownAdres,
		closeUnknownAdresModal,
		hasFocus,
		isCorrespondentieAdres,
		isExploitatatieAdres
	} = props;

	//MINIMUM: provide a model and an onChange function. Provide reference data (landen, postcodeGemeenten, straten) as well
	//OPTIONAL: errors object and originalModel object for showing errors and showing the original value of a field respectively
	//			for the confirm unknown streetname modal, provide a showUnknownToPartnerModal, confirmUnknownAdres and closeUnknownAdresModal

	return (
		<div>
			{showUnknownToPartnerModal ? <ConfirmModal
				isOpen={showUnknownToPartnerModal}
				title="Onbekend adres"
				mainText={"De ingegeven straat is niet gekend. Bent u zeker van de schrijfwijze?"}
				confirmAction={confirmUnknownAdres}
				cancelAction={closeUnknownAdresModal}
				confirmText="Ja"
				cancelText="Nee"
			/> : null}
			{ isCorrespondentieAdres ? 
			<Row>
				<SelectInput
					name="beschrCorrespAdrEnum"
					label="Beschrijving soort correspondentieadres"
					value={model.beschrCorrespAdrEnum}
					size={12}
					validationMessage={errors ? errors['beschrCorrespAdrEnum'] : ""}
					items={beschrCorrespAdressen.map(x => ({ value: x.beschrCorrespAdrEnum, label: x.naam }))}
					onChange={onChange} />
			</Row> : null}
			{ isExploitatatieAdres ? 
			<Row>
				<TextInput
						name="beschrExplAdr"
						label="Beschrijving locatie exploitatieadres"
						value={model.beschrExplAdr}
						onChange={onChange}
						tooltip={"vb 'parking café de sportvriend' ,  'CC Den Boom - Lindezaal', …"}
						validationMessage={errors ? errors['beschrExplAdr'] : ""}
						size={12}
						originalValue={originalModel ? originalModel.beschrExplAdr : undefined}
						hideRevert
						markChange
					/>
			</Row> : null}
			<Row>
				<AutoComplete
					items={landen}
					size={5}
					name="land"
					label="Land"
					value={model.land}
					onChange={onChange}
					disabled={!landen || !landen.length}
					useDefaultItem
					validationMessage={errors ? errors['land'] : ""}
					originalValue={originalModel ? originalModel.land : undefined}
					hideRevert
					markChange
					defaultItem="België"
				/>
				{model.land === LandCodes.BELGIE || !model.land ?
					<AutoComplete
						items={postcodeGemeenten || []}
						size={7}
						name="postcodeGemeente"
						label="Postcode - Gemeente"
						value={model.postcodeGemeente}
						onChange={onChange}
						disabled={!postcodeGemeenten || !postcodeGemeenten.length}
						minSearchLength={1}
						validationMessage={errors ? errors['postcode'] : ""}
						useDefaultItem={false}
						clearable
						hasFocus={hasFocus}
					/> :
					<TextAreaInput
						name="internationaalAdres"
						label="Internationaal adres"
						value={model.internationaalAdres}
						onChange={onChange}
						height={4}
						validationMessage={errors ? errors['internationaalAdres'] : ""}
						originalValue={originalModel ? originalModel.internationaalAdres : undefined}
						hideRevert
						markChange
					/>
				}
			</Row>
			{model.land === LandCodes.BELGIE || !model.land ?
				<Row>
					<AutoComplete
						items={straten || []}
						size={7}
						name="straat"
						label="Straat"
						value={model.straat}
						onChange={onChange}
						disabled={!(straten && straten.length && ((model.postcode && model.gemeente) || model.postcodeGemeente))}
						isLoading={stratenLoading}
						minSearchLength={1}
						allowFreeText
						useDefaultItem={false}
						validationMessage={errors ? errors['straat'] : ""}
						orangeBackground={!model.straatId && model.straat}
						clearable
						originalValue={originalModel ? originalModel.straat : undefined}
						hideRevert
						markChange
					/>
					<TextInput
						name="huisnummer"
						label="Huisnummer"
						value={model.huisnummer}
						onChange={onChange}
						disabled={(!model.straat && !model.straatId)}
						validationMessage={errors ? errors['huisnummer'] : ""}
						size={3}
						originalValue={originalModel ? originalModel.huisnummer : undefined}
						hideRevert
						markChange
					/>
					<TextInput
						name="busnummer"
						label="Busnummer"
						value={model.busnummer}
						onChange={onChange}
						disabled={(!model.huisnummer && !model.huisnummerId)}
						validationMessage={errors ? errors['busnummer'] : ""}
						size={2}
						originalValue={originalModel ? originalModel.busnummer : undefined}
						hideRevert
						markChange
						optional
					/>
				</Row> : null
			}
		</div>
	);
};

AdresInput.propTypes = {
	model: PropTypes.object,
	originalModel: PropTypes.object,
	errors: PropTypes.object,
	landen: PropTypes.array,
	postcodeGemeenten: PropTypes.array,
	straten: PropTypes.array,
	beschrCorrespAdressen: PropTypes.array,
	onChange: PropTypes.func,
	stratenLoading: PropTypes.bool,
	showUnknownToPartnerModal: PropTypes.bool,
	confirmUnknownAdres: PropTypes.func,
	closeUnknownAdresModal: PropTypes.func,
	hasFocus: PropTypes.bool,
	isExploitatatieAdres: PropTypes.bool,
	isCorrespondentieAdres: PropTypes.bool
};

export default AdresInput;
